import { Paper, Tooltip, Box, InputBase, IconButton } from '@mui/material';
import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export const SIGN_IN_TOOLTIP_TEXT = 'Sign in to activate LLM-based workspace.';

export const AskAIBox = ({ chatDraft, setChatDraft, setIsAiSearchFocused, isAskAiInProgress, handleChatSubmit, isAuthenticated, placeholder, inputRef, children }: { chatDraft: string, setChatDraft: (draft: string) => void, setIsAiSearchFocused: (focused: boolean) => void, isAskAiInProgress: boolean, handleChatSubmit: (event: React.FormEvent<HTMLFormElement>) => void, isAuthenticated: boolean, placeholder: string, inputRef: React.Ref<HTMLInputElement>, children?: React.ReactNode }) => {
	return (
		<Paper sx={{ flex: 1, alignSelf: { xs: 'stretch', md: 'auto' } }}>
			{children}
			<Tooltip title={!isAuthenticated ? SIGN_IN_TOOLTIP_TEXT : ''} disableInteractive>
				<Box
					component='form'
					onSubmit={(event) => {
						event.preventDefault();
						handleChatSubmit(event);
					}}
					sx={(theme) => ({ display: 'flex', alignItems: 'center', gap: 1, p: theme.spacing(1, 2), borderRadius: 'inherit', '&:focus-within': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: '-2px' } })}
					flex={1}
				>
					<InputBase
						sx={{ ml: 1, flex: 1 }}
						placeholder={placeholder}
						autoComplete='off'
						name='message'
						value={chatDraft}
						onChange={(event) => setChatDraft(event.target.value)}
						onFocus={() => setIsAiSearchFocused(true)}
						onBlur={() => setIsAiSearchFocused(false)}
						disabled={!isAuthenticated}
						autoFocus
						inputRef={inputRef}
					/>
					<IconButton color='primary' type='submit' disabled={!chatDraft.trim() || isAskAiInProgress}>
						<AutoAwesomeIcon fontSize='small' />
					</IconButton>
				</Box>
			</Tooltip>
		</Paper>
	);
};